import { careerJourney } from '../data/skills';
import { experiences } from '../data/experience';
import { ui } from '../data/ui';
import { SEO } from '../components/ui/SEO';
import { SectionHeader } from '../components/ui/SectionHeader';
import { TimelineItem } from '../components/ui/TimelineItem';
import { ScrollReveal } from '../components/ui/ScrollReveal';
import './ExperiencePage.css';

export function ExperiencePage() {
  return (
    <>
      <SEO title={ui.seo.experience} description={ui.experience.professionalExperienceSub} />

      <div className="page-header">
        <div className="container">
          <SectionHeader
            label={ui.sections.career}
            title={ui.experience.professionalExperience}
            subtitle={ui.experience.professionalExperienceSub}
            align="center"
          />
        </div>
      </div>

      <section className="section">
        <div className="container">
          <ScrollReveal className="full-journey">
            <p className="journey-label">{ui.experience.completeProgression}</p>
            <div className="journey-track">
              {careerJourney.map((step, i) => (
                <div key={step} className="journey-step">
                  <span className={`journey-dot ${i === careerJourney.length - 1 ? 'journey-dot-current' : ''}`} />
                  <span className={`journey-text ${i === careerJourney.length - 1 ? 'journey-text-current' : ''}`}>
                    {step}
                  </span>
                  {i < careerJourney.length - 1 && <span className="journey-arrow">←</span>}
                </div>
              ))}
            </div>
          </ScrollReveal>

          <div className="timeline">
            {experiences.map((exp, i) => (
              <TimelineItem
                key={exp.id}
                experience={exp}
                index={i}
                isLast={i === experiences.length - 1}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
